import { useThunkReducer } from '@shared/hooks/useThunkReducer';
import { selectPhysicalAddresseAttributes } from '@shared/reducers/user';
import React from 'react';
import { useSelector as useReduxSelector } from 'react-redux';
import { FlowStep } from '../../components/FlowStep';
import { StepSmartPhysicalAddressConfirm } from './components/StepSmartPhysicalAddressConfirm';
import { StepSmartPhysicalAddressField } from './components/StepSmartPhysicalAddressField';
import { StepSmartPhysicalAddressSearch } from './components/StepSmartPhysicalAddressSearch';
import { StepSmartPhysicalAddressSelect } from './components/StepSmartPhysicalAddressSelect';
import {
  init,
  selectCurrentStep,
  selectLabel,
  selectMessage,
  stepSmartPhysicalAddressReducer,
} from './reducers/stepSmartPhysicalAddressReducer';

export const StepSmartPhysicalAddress = (props) => {
  const physicalAddressAttributes = useReduxSelector(selectPhysicalAddresseAttributes);
  const initializerArg = {
    data: props.data,
    physicalAddressAttributes: physicalAddressAttributes,
  };
  const [state, dispatch, useSelector] = useThunkReducer(stepSmartPhysicalAddressReducer, {
    devToolsName: props.devToolsName,
    initializerArg: initializerArg,
    initializer: init,
  });

  const currentStep = useSelector(selectCurrentStep);
  const label = useSelector((state) => selectLabel(state, props.config));
  const message = useSelector((state) => selectMessage(state, props.config, props.data));

  return (
    <FlowStep key={currentStep} label={label} message={message}>
      {React.createElement(getStepBy(currentStep), {
        state: state,
        dispatch: dispatch,
        useSelector: useSelector,
        required: props.config.required,
        onComplete: props.completeStep,
      })}
    </FlowStep>
  );
};

const stepBy = {
  search: StepSmartPhysicalAddressSearch,
  confirm: StepSmartPhysicalAddressConfirm,
  field: StepSmartPhysicalAddressField,
  select: StepSmartPhysicalAddressSelect,
};

const getStepBy = (currentStep) => stepBy[currentStep] ?? stepBy.field;
